import * as React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from "@/lib/utils";

export interface CardBadgeProps {
  brand?: string;
  last4?: string;
  className?: string;
}

// Format brand name for display
const formatBrand = (brand: string): string => {
  const brandLower = brand.toLowerCase();

  switch (brandLower) {
    case 'amex':
      return 'Amex';
    case 'mastercard':
      return 'Mastercard';
    case 'visa':
      return 'Visa';
    case 'discover':
      return 'Discover';
    case 'jcb':
      return 'JCB';
    case 'diners':
    case 'diners club':
      return 'Diners';
    case 'unionpay':
      return 'UnionPay';
    default:
      return brand.charAt(0).toUpperCase() + brand.slice(1);
  }
};

/**
 * CardBadge component displays card brand and last 4 digits
 */
export function CardBadge({ brand, last4, className }: CardBadgeProps) {
  // Handle completely missing card data
  if ((!last4 || last4 === '-') && (!brand || brand === '-')) {
    return <span className={cn('text-muted-foreground text-sm', className)}>—</span>;
  }

  const hasBrand = brand && brand !== '-';
  const hasLast4 = last4 && last4 !== '-';

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Badge variant="gray" className="min-w-[72px] justify-center">
        {hasBrand ? formatBrand(brand!) : 'Card'}
      </Badge>
      {hasLast4 && <span className="text-muted-foreground text-sm tabular-nums">•••• {last4}</span>}
    </div>
  );
}
